import { palette } from '@kimuno/theme';
import { IconButton, type IconButtonProps, SvgIcon, Tooltip } from '@mui/material';
import type React from 'react';
import { forwardRef } from 'react';

import getMuiIcon, { type IconName } from '../../../utils/getMuiIcon';

export type AIAssistantIconButtonProps = {
	icon: IconName;
	tooltip?: string;
	iconSize?: 'medium' | 'large';
} & IconButtonProps;

const AIAssistantIconButton: React.FC<AIAssistantIconButtonProps> = forwardRef(
	({ icon, tooltip, iconSize = 'medium', ...props }, ref) => {
		const iconSizePx = iconSize === 'medium' ? 24 : 32;

		const buttonStyles = {
			color: palette.text.secondary,
			'&:hover': {
				backgroundColor: palette.primary.hover,
				color: palette.primary.main,
			},
			...props.sx,
		};

		const button = (
			<IconButton
				{...props}
				sx={buttonStyles}
				ref={ref}
				type={props.type || 'button'}
				aria-label={props['aria-label'] || tooltip || undefined}
			>
				<SvgIcon
					sx={{ width: iconSizePx, height: iconSizePx }}
					viewBox={`0 0 ${iconSizePx} ${iconSizePx}`}
					component={getMuiIcon(icon)}
					aria-hidden="true"
				/>
			</IconButton>
		);

		return tooltip ? (
			<Tooltip title={tooltip} placement="top" arrow>
				{button}
			</Tooltip>
		) : (
			button
		);
	}
);

export default AIAssistantIconButton;
